import { Card, Nav, Spinner } from 'react-bootstrap';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const STEPS = [
  { id: 1, label: 'معرفی' },
  { id: 2, label: 'گوگل کلاد' },
  { id: 3, label: 'وضعیت ایندکس' },
  { id: 4, label: 'درخواست ایندکس' },
  { id: 5, label: 'زمان‌بندی' },
  { id: 6, label: 'پایان' },
];

export function OnboardingStepper({ currentStep }: { currentStep: number }) {
  return (
    <>
      <style>{`
        .indexer-onboarding-wizard.theme-wizard .nav-link.active:not(.nav-pills .active) {
          color: var(--falcon-navbar-vertical-default-link-active-color);
        }
        .indexer-onboarding-wizard.theme-wizard .nav-link.active .nav-item-circle {
          background-color: var(--falcon-navbar-vertical-default-link-active-color) !important;
          border-color: var(--falcon-navbar-vertical-default-link-active-color) !important;
        }
      `}</style>
      <Card className="theme-wizard indexer-onboarding-wizard mb-4">
        <Card.Header className="bg-body-tertiary">
          <Nav className="justify-content-center flex-nowrap overflow-auto">
            {STEPS.map(step => (
              <StepperNavItem
                key={step.id}
                index={step.id}
                currentStep={currentStep}
                label={step.label}
              />
            ))}
          </Nav>
        </Card.Header>
      </Card>
    </>
  );
}

function StepperNavItem({
  index,
  currentStep,
  label,
}: {
  index: number;
  currentStep: number;
  label: string;
}) {
  const done = currentStep > index;
  const active = currentStep === index;

  return (
    <Nav.Item>
      <Nav.Link
        className={classNames('fw-semibold', { done, active })}
        onClick={() => {}}
      >
        <span className="nav-item-circle-parent p-0 p-md-1">
          {index < currentStep ? (
            <span className="nav-item-circle">
              <FontAwesomeIcon icon="check" />
            </span>
          ) : index === currentStep ? (
            <span className="nav-item-circle">
              <Spinner
                animation="border"
                role="status"
                style={{ color: '#121e2d', verticalAlign: 'middle' }}
              />
            </span>
          ) : (
            <span className="nav-item-circle">
              <FontAwesomeIcon icon="check" />
            </span>
          )}
        </span>
        <span className="d-none d-md-block mt-1 fs-10">{label}</span>
      </Nav.Link>
    </Nav.Item>
  );
}
